import React, { useContext } from 'react';
import moment from 'moment';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import { WatchFullInfoContext, IWatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';

export const CreatedField: React.FC = () => {
	const { watchFullInfo } = useContext<IWatchFullInfoContext>(WatchFullInfoContext);

	const inputValue = watchFullInfo?.insertedDate
		? `${moment(watchFullInfo.insertedDate).format('MM/DD/YYYY h:mm:ss A')} ${watchFullInfo.insertedBy}`
		: '-';

	return <FullInfoField label="createdLabel" value={inputValue} />;
};
